import React, {
	useEffect,
	useState
}from "react"
import {
	 Modal,
	 Form,
	 Select
}from "antd"
import {
	useDebounce
}from "use-debounce"
import {
	useSelector,
	useDispatch
}from 'react-redux'
import CustomSelect from "../../../components/CustomSelect"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import {
	reRegionActions
}from '../ReRegion/store/actions'

const { Option } = Select

const ReDistrictChangeForm = (props) => {
	const dispatch = useDispatch()
	const regions = useSelector(state => state.reRegionReducer.list)
	const [searchRegion, setSearchRegion] = useState('')
	const [region] = useDebounce(searchRegion, 500)
	const getRegions = (values) => {
		dispatch(reRegionActions.getList(values))
	}

	const { isSending, changed } = useSelector((state) => state.reDistrictReducer)
	const { visible, setVisible, setRecord, record, create, update } = props
	const [form] = Form.useForm()
	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				code   : record.code,
				region : record.regionId,
				name   : record.name
			})
			setSearchRegion(record.regionName)
		}
	}, [record])

	useEffect(() => {
		return () => {
			dispatch(reRegionActions.clear())
		}
	}, [])

	useEffect(() => {
		getRegions({
			name: region?.trim()
		})
	}, [region])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id         : record?.id,
				code       : values.code,
				region     : values.region,
				name       : values.name.trim(),
				createDate : record?.createDate,
				isDeleted  : record?.isDeleted
			}
			const previousValues = {
				id         : record?.id,
				code       : record?.code,
				region     : record?.regionId,
				name       : record?.name,
				createDate : record?.createDate,
				isDeleted  : record?.isDeleted
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
          Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование записи" : "Добавление записи" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { span   : 16,
					offset : 1 } }
			>
				<Form.Item
					label="Код"
					name="code"
					rules={ [
						{
							required   : true,
							whitespace : true,
							message    : "Код заполнен некорректно.",
							pattern    : /^[1-9]\d{0,6}$/
						}
					] }
				>
					<CustomInput
						placeholder="Введите код"
					/>
				</Form.Item>
				<Form.Item
					label="Область"
					name="region"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберить область"
						onSearch={ (e) => setSearchRegion(e) }
					>
						{ regions?.map(item => {
							return (
								<Option
									key={ item.id }
									value={ item.id }
								>
									{ item.name }
								</Option>)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Название"
					name="name"
					rules={ [
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 500
						}
					] }
				>
					<CustomInput
						maxLength={ 550 }
						placeholder="Введите название"
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReDistrictChangeForm
